module.exports = __webpack_public_path__ + "img/classroom.e9f8844e.jpg";